import {NgModule} from '@angular/core';
import {ValidateOnBlurDirective} from './validate-on-blur.directive';
import {ClickOutsideDirective} from './click-outside.directive';
import {PopoverMessageDirective} from './popover-message.directive';
import {InputmaskDirective} from './inputmask/inputmask.directive';
import {InputmaskGlossary} from './inputmask/inputmask-library';
import {InputMaskInitDirective} from './inputmask-init.directive';
import {FallbackImageDirective} from './fallback-image.directive';
import {RostehRegionsPreviewDirective} from './rosteh-regions-preview/rosteh-regions-preview.directive';
import {CheckAccessDirective} from './checkAccess/checkAccess.directive';

/**
 * Модуль со всеми глобальными директивами проекта
 */

@NgModule({
    declarations: [
        ValidateOnBlurDirective,
        ClickOutsideDirective,
        PopoverMessageDirective,
        InputmaskDirective,
        InputMaskInitDirective,
        FallbackImageDirective,
        RostehRegionsPreviewDirective,
        CheckAccessDirective,
    ],
    exports: [
        ValidateOnBlurDirective,
        ClickOutsideDirective,
        PopoverMessageDirective,
        InputmaskDirective,
        InputMaskInitDirective,
        FallbackImageDirective,
        RostehRegionsPreviewDirective,
        CheckAccessDirective,
    ],
    providers: [
        { provide: 'INPUTMASK_GLOSSARY', useValue: InputmaskGlossary },
    ]
})
export class DirectivesModule {}
